import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DISCOUNT_CODE_CATEGORY_COLUMNS } from '../../../../config/columns';
import {
  clearFreeOfChargeCategories,
  getFreeOfChargeCategories,
} from '../../../../actions/sales/FreeOfChargeCategory';
import {
  FREE_OF_CHARGE_CATEGORY_PATH,
  NEW_FREE_OF_CHARGE_CATEGORY_PATH,
} from '../../../../config/paths';

export const FreeOfChargeCategories = ({
  breadcrumbs,
  freeOfChargeCategories,
  loading,
  dispatchGetFreeOfChargeCategories,
  dispatchClearFreeOfChargeCategories,
}) => {
  useLayoutEffect(() => () => dispatchClearFreeOfChargeCategories(), []);

  const data = freeOfChargeCategories.get('content') || [];
  const pages = freeOfChargeCategories.get('totalPages') || null;
  const defaultPageSize =
    freeOfChargeCategories.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Categorías Para Servicios a Título Gratuito"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_FREE_OF_CHARGE_CATEGORY_PATH}
      tableStructure={{
        columns: DISCOUNT_CODE_CATEGORY_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetFreeOfChargeCategories,
        modelPath: FREE_OF_CHARGE_CATEGORY_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetFreeOfChargeCategories: getFreeOfChargeCategories,
  dispatchClearFreeOfChargeCategories: clearFreeOfChargeCategories,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Categoría Para Servicios a Título Gratuito',
      href: FREE_OF_CHARGE_CATEGORY_PATH,
    },
  ],
  freeOfChargeCategories: SalesUnit.FreeOfChargeCategory.getIn([
    'all',
    'content',
  ]),
  loading: SalesUnit.FreeOfChargeCategory.getIn(['all', 'loading']),
});

FreeOfChargeCategories.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  freeOfChargeCategories: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetFreeOfChargeCategories: PropTypes.func.isRequired,
  dispatchClearFreeOfChargeCategories: PropTypes.func.isRequired,
};

FreeOfChargeCategories.defaultProps = {
  freeOfChargeCategories: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FreeOfChargeCategories);
